import suppliers from "public/json/suppliers.json";
import { ISupplier, LimitationTypeEnum, PreparedSupplier } from "~/server/types/server.interface";
import listIncludesSublist from "@/utils/listIncludesSublist";
import { sortLevels } from "~/server/helpers/levels";
import { mapSubscriptionModelToLevels, OPEN_NOW_TAG_ID } from "~/constants";
import { extractLimitationProperty } from "~/server/helpers/extractLimitationProperty";
import { getTodayWorkingStatus } from "~/server/helpers/workingTime";

export const TEST_ACCOUNT_ID = "00331"; // Taken from suppliers.json

export const getSuppliersFromGeneratedSearchByFilters = async <T>(
  search: string,
  payload = {},
  callback: (supplier: ISupplier) => PreparedSupplier,
  subscriptionModel: number,
  event: any
) => {
  const preparedSuppliers: PreparedSupplier[] = [];
  // @ts-ignore
  const { city, activities, tags, search: payloadSearch, levels } = payload;
  const { preparedTags, shouldFilterByLimit } = extractLimitationProperty(tags);
  const escapedPayloadSearch = payloadSearch.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  // "id:00001 name of supplier address attraction1 attraction2 id:00002 etc."
  const pattern = "id\\:(\\d{5}).*?(?=id:|$)";

  String(search).replace(
    new RegExp(pattern, "gs"),
    (substring: string): string => {
      const isNecessarySearchStringExists = substring.match(new RegExp(escapedPayloadSearch, "gs"));
      if (!isNecessarySearchStringExists) return "";

      const lastIndex = substring.lastIndexOf("id:");
      const id: string = substring.substring(lastIndex + 3, lastIndex + 8);

      //Because we need test account to be invisible for clients on the site
      if(id === TEST_ACCOUNT_ID) return "";

      // @ts-ignore
      const supplier: ISupplier = suppliers[id];

      const separatedSortedLevels = {
        archived: sortLevels(supplier.levels.filter(level => level.isArchived), 0),
        default: sortLevels(supplier.levels.filter(level => !level.isArchived), 1),
      };

      const supplierWithSortedLevels = {
        ...supplier,
        levels: separatedSortedLevels[mapSubscriptionModelToLevels[subscriptionModel]],
      };

      if (supplier) {
        if (city && supplier.city && supplier.city !== city) {
          return "";
        }

        let supplierActivities: string[] | undefined;
        if (levels) {
          supplierActivities = supplierWithSortedLevels.levels.findLast(item =>
            levels.includes(item.id)
          )?.activities;
        }

        if (supplierActivities) {
          !Array.isArray(supplierActivities) &&
            (supplierActivities = Object.values(supplierActivities));
          if (
            activities &&
            !listIncludesSublist(activities, supplierActivities)
          ) {
            return "";
          }
        }

        const supplierTags = supplier.tags;
        const now = new Date();

        const { isOpenNow } = getTodayWorkingStatus(supplier.workingTime, supplier.country, now);

        if(preparedTags.includes(OPEN_NOW_TAG_ID) && isOpenNow) {
          preparedSuppliers.push(callback(supplierWithSortedLevels));
          return "";
        }

        if (preparedTags && !listIncludesSublist(preparedTags, supplierTags)) {
          return "";
        }

        preparedSuppliers.push(callback(supplierWithSortedLevels));
      }

      return "";
    }
  );

  if (shouldFilterByLimit) {
    return preparedSuppliers.filter((supplier) => {
      const highestSelectedLevel = supplier.levels.findLast((item) => levels.includes(item.id));
      if (highestSelectedLevel) {
        return highestSelectedLevel.limitationType !== LimitationTypeEnum.NONE;
      }

      return false;
    });
  }

  return preparedSuppliers;
};
